import { i18n } from '@/plugins/i18n'
import { shRequestStatusStr } from '@/constants/shaparakRequestStatus'
import { shRequestVariant } from '@/constants/shaparakRequestStatus'
import RejectionReasonsColumn from "../components/rejection-reasons";
import { shRequestStatus } from '@/constants/shaparakRequestStatus'
import createdRequestcolumn from "../components/created-request-columns2"
import store from '@/store'

const rejectionReasonTemplate = (row, index, datatable) => {
    let template = new RejectionReasonsColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

const createdRequestTemplate = (row, index, datatable) => {
    let template = new createdRequestcolumn({
        props: {
            row,
            index,
            datatable,
            store
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable
    template.store = store

    return template.$mount().$el
}

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 65,
        selector: false,
        textAlign: 'center',
    },
    {
        field: 'gateway_title',
        title: i18n.t('shaparakRequests.gateway_title'),
        template: (row) => {
            return '<a href="/gateways/' + row.gateway_id + '/details">'+row.gateway_title+'</a>'
        },
        sortable: false,
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'request_type',
        title: i18n.t('shaparakRequests.request_type'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('shaparakRequests.status'),
        textAlign: 'center',
        template: (row) => {
            let status  = shRequestStatusStr.get(row.status)
            let variant = 'badge-'+shRequestVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        sortable: true,
        width: 80,
    },
    {
        field: 'tracking_number',
        title: i18n.t('shaparakRequests.tracking_number'),
        width: 120,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('shaparakRequests.created_at'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'rejection_reason',
        title: i18n.t('shaparakRequests.description'),
        sortable: false,
        width: 80,
        template: (row, index, datatable) => {
            if (row.status === shRequestStatus.CREATED) {
                return createdRequestTemplate(row, index, datatable)
            } else {
                return rejectionReasonTemplate(row, index, datatable)
            }
        },
        textAlign: 'center',
    },

]